import { States } from 'src/app/enums/States';
import { Chat } from '../Chat/chat.service';
import { ModulesManagerService } from '../Module/modules-manager.service';
import { Field } from '../Field/field';
import { DateTimeField } from '../DateTimeField/date-time-field';
import { GeolocationField } from '../GeolocationField/geolocation-field';
import { DocumentsField } from '../DocumentsField/documents-field';
import { SelectorField } from '../SelectorField/selector-field';
import { Documents } from '../Documents/documents';
import { PhoneNumberField } from '../PhoneNumberField/phone-number-field';
import { Notification } from '../Notification/notification';
import { LoggerService } from '../../utils/logger.service';
import { Share } from '../Share/share';

export class Ask {
  private id: number = 0;
  private fakeChat: Chat;
  private internalKey = null;
  private state: States = States.Creating;
  private structure: Array<Field> = new Array<Field>();
  private isFake = false
  private gmaoRef = 0;
  private ownerId = 0;
  private originalOwnerId = 0;
  private verifyCode = "";
  private targetId = 0;
  private originalTargetId = 0;
  private deleteDate = 0;
  private ownerDisplayName = "";
  private ownerDisplayEmail = "";
  private targetDisplayEmail = "";
  private received: boolean = false;
  private modified: boolean = false;
  private hydrated: boolean = false;
  private targetSociety: string = "";
  private ownerSociety: string = "";
  //private Structure: Array<Field>= new Array<Field>();
  constructor(private manager: ModulesManagerService, isFake = false) {
    this.isFake = isFake

    //this.Test()
  }

  get GmaoRef() {
    return this.gmaoRef
  }

  get IsFake() {
    return this.isFake
  }

  get Id() {
    return this.id
  }

  get OwnerId() {
    return this.ownerId
  }

  get TargetId() {
    return this.targetId
  }

  get IsVerified() {
    return this.verifyCode == ""
  }

  get Received() {
    return this.received
  }

  get OwnerDisplayName() {
    return this.ownerDisplayName
  }

  get OwnerSociety() {
    return this.ownerSociety
  }

  get TargetSociety() {
    return this.targetSociety
  }

  get TargetDisplayEmail() {
    return this.targetDisplayEmail
  }

  get OwnerDisplayEmail() {
    return this.ownerDisplayEmail
  }

  get displayValidateChoice() {
    return this.State == States.Over && !this.Received && this.isOwner
  }

  get hasDeleteDate() {
    return this.deleteDate > 0
  }
  private diplsayedDeleteDate = null
  private displayedDeleteDateValue = ""
  get DisplayDeleteDate() {
    if (this.diplsayedDeleteDate != this.deleteDate) {
      this.diplsayedDeleteDate = this.deleteDate
      this.displayedDeleteDateValue = (new Date(this.deleteDate))["getFromFormat"](this.manager.Trad.Parse("STR_FULLDATE_SHOW"))
    }
    return this.displayedDeleteDateValue
  }

  get OriginalOwnerId() {
    return this.originalOwnerId
  }

  get OriginalTargetId() {
    return this.originalTargetId
  }

  get Hydrated() {
    return this.hydrated && this.DisplayedData?.Title
  }

  get IsWaitingMailCheck() {
    return this.state == States.Creating
  }

  async Test() {
    await this.SendMessage("My Massage's faut finir le visuelle coco");
    //await this.manager.Tool.sleep(10000);
    //(await this.SendMessage("My Massage's faut finir le visuelle coco")).userId = 999
  }

  async Hydrate(Data, UpdateAnnex = false) {
    // hydrate les setter 
    this.hydrated = false
    for (const [property, value] of Object.entries(Data)) {
      if (property == "structure") continue;
      this[this.manager.Tool.minimilizeFirstChar(property)] = value
    }
    if (Data["structure"]) {
      let isMobile = !this.manager.Tool.isPlatform("web")
      for (const [key, data] of Object.entries(Data["structure"])) {
        data["isMobile"] = isMobile
        switch (data["Type"]) {
          case "textarea":
          case "boolean":
          case "input":
            this.structure.push(new Field(this.manager, data))
            break
          case "datetime":
            this.structure.push(new DateTimeField(this.manager, data))
            break
          case "phonenumber":
            this.structure.push(new PhoneNumberField(this.manager, data))
            break
          case "selector":
            this.structure.push(new SelectorField(this.manager, data))
            break
          case "geolocation":
            this.structure.push(new GeolocationField(this.manager, data))
            break
          case "document":
            this.structure.push(new DocumentsField(this.manager, data))
            break
          default:
            LoggerService.warn("type de champ non géré", data["Type"])
            break
        }
      }
    }
    if (this.internalKey == null) {
      if (Data["InternalKey"])
        this.internalKey = Data["InternalKey"]
      if (this.internalKey == null && this.isFake) {
        this.internalKey = await this.manager.Tool.GetDeviceId() + "-_-" + ((new Date()).getTime())
        this.manager.addInternalKey(this.internalKey)
      }
    }

    this.fakeChat = new Chat(this.manager, {
      Id: 0,
      OwnerId: this.ownerId,
      AskId: this.Id,
      Content: "",
    })
    if (UpdateAnnex) {
      await this.LoadField()
      await this.LoadChat()
      await this.LoadNotification()
      await this.LoadShare()
    }
    this.hydrated = true
  }


  public async ImportBackDocuments(datas) {
    LoggerService.log("ImportBackDocuments datas:", datas)
    for (const documentToRestore of datas) {
      let document: Documents = await this.manager.GetModuleData("Documents", documentToRestore.Id)
      documentToRestore.parentId = this.id
      documentToRestore.parentModule = "Ask"
      documentToRestore.imported = true
      documentToRestore.integrityChecked = true
      await document.Hydrate(documentToRestore)
    }
  }

  private timeOutUpdate: any = null
  public ForceUpdate() {
    if (this.timeOutUpdate != null) clearTimeout(this.timeOutUpdate)

    this.timeOutUpdate = setTimeout(async () => {
      // this.Structure.forEach((field)=>{ if(field.AskId>0)this.manager.deleteModuleData("Fields", field.Id)})
      //this.structure= []
      //this.manager.GetListModuleData("Fields", "Ask", this.id).forEach((field:Field)=>{ if(field.AskId>0)this.manager.deleteModuleData("Fields", field.Id)})
      await this.LoadField()
      this.timeOutUpdate = null
    }, 3000)
  }

  private pendingShare = false

  private async LoadShare() {
    if (this.isFake) return;
    if (this.pendingShare) return
    this.pendingShare = true
    await this.manager.LoadList("Shares", "Ask", this.id).catch(LoggerService.error);
    this.pendingShare = false
  }

  private pendingChat = false

  private async LoadChat() {
    if (this.isFake) return;
    if (this.pendingChat) return
    this.pendingChat = true
    await this.manager.LoadList("Chats", "Ask", this.id).catch(LoggerService.error);
    this.pendingChat = false
  }

  private pendingNotification = false
  private async LoadNotification() {
    if (this.isFake) return;
    if (this.pendingNotification) return;
    this.pendingNotification = true
    await this.manager.LoadList("Notifications", "Ask", this.id).catch(LoggerService.error);
    this.pendingNotification = false
  }

  private pendingDocument = false
  async LoadDocument() {
    if (this.pendingDocument) return;
    this.pendingDocument = true
    if (this.isFake) return;
    await this.manager.LoadList("Documents", "Ask", this.id).catch(LoggerService.error);
    this.pendingDocument = false
  }

  private pendingField = false
  private async LoadField() {
    if (this.isFake) return;
    if (this.pendingField) return;
    this.pendingField = true
    await this.manager.LoadList("Fields", "Ask", this.id).catch(LoggerService.error);

    //this.structure =this.manager.GetListModuleData("Fields", "Ask", this.id)
    this.pendingField = false
    await Promise.all(this.Structure.map((field: Field) => field.postRenderHtml(this)))
  }

  public hasFieldContain(lookingFor: string = ""): boolean {
    if (this.targetDisplayEmail.includes(lookingFor) || this.ownerDisplayEmail.includes(lookingFor) || this.Shares.find(user => {
      return user.Email.includes(lookingFor)
    }))
      return true;
    return this.Structure.findIndex((field: Field) => {
      return field.isFilterValid(lookingFor)
    }) != -1 || this.GmaoRef.toString().includes(lookingFor)
  }

  get ChatNotification(): number {
    return this.Notifications.find((notification) => notification.Parent == "Chat" && notification.AskId == this.Id)?.Quantity || 0
  }

  get NewThings(): boolean {
    return (this.Notifications.find((notification) => notification.Parent == "Ask" && notification.AskId == this.Id)?.Quantity || 0) > 0
  }

  private cachedData: { timeToKeep: number, data: any } = null

  get DisplayedData() {

    if (this.cachedData && this.cachedData.timeToKeep > Date.now()) return this.cachedData.data

    let Data = {}
    for (let field of this.Structure) {
      Data[field.TargetField] = field.Value
    }

    this.cachedData = {
      timeToKeep: Date.now() + 2000,
      data: Data
    }


    return Data
  }


  displayField(FieldTargetName: string) {
    return this.DisplayedData[FieldTargetName] || ""
    /*let field : Field= this.getField({
      TargetField: FieldTargetName
    })*/
    //return field?.Value || "" 
  }

  get CanAddShares() {
    return this.state >= States.New
  }

  get State() {
    return this.state
  }

  set State(vale) {
    this.state = vale
  }

  get StateLabel() {
    let label = ""
    switch (this.state) {
      case States.Creating:
        label = "STR_CREATING"
        break
      case States.New:
        label = "STR_NEW"
        break
      case States.Todo:
        label = "STR_TODO"
        break
      case States.Running:
        label = "STR_RUNNING"
        break
      case States.Over:
        label = "STR_OVER"
        break
      case States.Archived:
        label = "STR_ARCHIVED"
        break
      default:
        LoggerService.warn("unknow State enum " + this.state)
        break
    }
    return this.manager.Trad.Parse(label)
  }


  get Structure() {
    return (this.isFake ? this.structure : this.manager.GetListModuleData("Fields", "Ask", this.id)).sort((a, b) => a.Order - b.Order)
  }

  get Shares(): Array<Share> {
    return this.isFake ? [] : this.manager.GetListModuleData("Shares", "Ask", this.id)
  }

  get InternalKey() {
    return this.internalKey
  }

  private isPendingAskRead = false
  async readedAsk() {
    if (this.isPendingAskRead) return
    this.isPendingChatRead = true
    if (this.NewThings) {
      await this.manager.Ws.Send("Notifications", "read", { AskId: this.id, Parent: "Ask" }, true)
      await this.manager.Tool.sleep(5000)
    }
    this.isPendingChatRead = false
  }

  private isPendingChatRead = false
  async readedChat() {
    if (this.isPendingChatRead) return
    this.isPendingChatRead = true
    if (this.ChatNotification > 0) {

      await this.manager.Ws.Send("Notifications", "read", { AskId: this.id, Parent: "Chat" }, true)

      await this.manager.Tool.sleep(5000)
    }
    this.isPendingChatRead = false
  }

  get DocumentsCount() {
    return this.getField({ TargetField: "Document" })?.Value?.length || 0
  }


  set InternalKey(value) {
    if (this.internalKey == null && this.isFake)
      this.internalKey = value
  }

  getField(Filters: any): Field {
    for (const [properties, value] of Object.entries(Filters))
      for (const [key, field] of Object.entries(this.Structure))
        switch (value) {
          case "C_Equi":
            if (properties == "TargetField") {
              if (field[properties] == value || field[properties] == "equi") return field
            } else {
              if (field[properties] == value) return field
            }
            break;
          case "C_Arbo":
            if (properties == "TargetField") {
              if (field[properties] == value || field[properties] == "arbo") return field
            } else {
              if (field[properties] == value) return field
            }
            break;
          default:
            if (field[properties] == value) return field
            break;
        }
    return null

  }

  get Modified() {
    return this.modified
  }

  set Modified(value) {
    this.modified = value
  }

  get Chats(): Array<Chat> {
    if (this.isFake) return []
    let chats: Array<Chat> = this.manager.GetListModuleData("Chats", "Ask", this.id)
    if (this.deleteDate > 0) {
      this.fakeChat.Content = this.manager.Trad.Parse("STR_CHAT_DELETE_AT", { Date: new Date(this.deleteDate)["getFromFormat"](this.manager.Trad.Parse("STR_FULLDATE_SHOW")) })
      chats.push(this.fakeChat)
    }
    return chats
  }


  get Notifications(): Array<Notification> {
    return this.manager.GetListModuleData("Notifications", "Ask", this.id)
  }

  private diplsayedFormatedDate = null
  private displayedFormatedDateValue = ""

  get formatedDate(): string {
    let field = (this.getField({ TargetField: "CreatedDate" }) as any)?.Date
    if (this.diplsayedFormatedDate != field) {
      this.diplsayedFormatedDate = field
      this.displayedFormatedDateValue = (new Date(field))["getFromFormat"](this.manager.Trad.Parse("STR_FULLDATE_SHOW"))
    }
    return this.displayedFormatedDateValue
    // return new Date((this.getField({TargetField:"CreatedDate"})as any)?.Date)["getFromFormat"](this.manager.Trad.Parse("STR_FULLDATE"));
  }

  get isShared() {
    return this.Shares.find(s => s.UserId == this.manager.Usr.UserId) != null
  }

  get isOldOwner() {
    return this.manager.Usr.UserId == this.originalOwnerId || (this.manager.hasInternalKey(this.internalKey) && this.originalOwnerId != 0)
  }

  get isOwner() {
    if (this.isFake) return true
    return this.manager.Usr.UserId == this.ownerId || (this.manager.hasInternalKey(this.internalKey) && this.originalOwnerId <= 0)
  }

  get isTarget() {
    return this.manager.Usr.UserId == this.targetId
  }

  get isOldTarget() {
    return this.manager.Usr.UserId == this.originalTargetId
  }

  get isTwoSideAtTime() {
    return this.isOwner && this.targetDisplayEmail == this.ownerDisplayEmail && !this.isFake
  }

  public async validate() {
    if (!this.isOwner) return;
    let resu = await this.manager.Ws.Send("Asks", 'sealed', {
      Id: this.id
    }, true)
    if (resu.error) this.manager.Tool.notify(this.manager.Trad.Parse(resu.error))
  }

  get isDeletable() {
    return (this.isOwner || this.isTwoSideAtTime) && !this.hasDeleteDate
  }

  get isArchivable() {
    return (this.isOwner || this.isTwoSideAtTime) && !this.hasDeleteDate && this.state != States.Archived
  }

  public async delete(displayMessage: boolean = true) {
    let resu = await this.manager.Ws.Send("Asks", "delete", { Id: this.id }, true)
    if (resu.error)
      this.manager.Tool.notify(this.manager.Trad.Parse(resu.error))
    else if (displayMessage)
      this.manager.Tool.notify(this.manager.Trad.Parse(resu.success))
  }

  public async archive(displayMessage: boolean = true) {
    let resu = await this.manager.Ws.Send("Asks", "archive", { Id: this.id }, true)
    if (resu.error)
      this.manager.Tool.notify(this.manager.Trad.Parse(resu.error))
    else if (displayMessage)
      this.manager.Tool.notify(this.manager.Trad.Parse(resu.success))
  }

  public async notOver() {
    if (!this.isOwner) return;
    let resu = await this.manager.Ws.Send("Asks", 'notConfirmed', {
      Id: this.id
    }, true)

    if (resu.error) this.manager.Tool.notify(this.manager.Trad.Parse(resu.error))
  }

  async SendMessage(Message: string) {
    //let Chat = await this.manager.GetModuleData("Chats", this.manager.newId("Chats"), "Ask", this.id) as Chat
    //await Chat.<sendMessage>( Message , this.id) 
    let data = {
      Content: Message,
      AskId: this.Id,
      ModifiedDate: 0,
      CreatedDate: (new Date()).getTime()
    }

    let resu = await this.manager.Ws.Send("Chats", "creatChat", data, true)

    if (resu.error) this.manager.Tool.notify(this.manager.Trad.Parse(resu.error))
  }

  public async copyAnswer() {
    let data = {}
    for (const field of this.Structure) {
      if (field.TargetField == "Document") continue;
      data[field.TargetField] = await field.exportValue()
    }
    return data
  }

  public async copyDocuments() {
    let data = {}
    for (const field of this.Structure) {
      if (field.TargetField != "Document") continue;
      data[field.TargetField] = await field.exportValue()
    }
    return data
  }

  public checkForImposedField(): boolean {
    for (const field of this.Structure)
      if (field.IsImposedAndNotFilled) return false
    return true
  }

  async SendChatDocuments(event: any | File) {
    let data = {
      Content: "img",
      AskId: this.Id,
      ModifiedDate: 0,
      CreatedDate: (new Date()).getTime()
    }

    let resu = await this.manager.Ws.Send("Chats", "creatChat", data, true)
    if (resu.Data.Id > 0) {
      let Id: number = this.manager.newId("Documents")// générate new one
      let document: Documents = await this.manager.GetModuleData("Documents", Id)
      if (!event.target) {
        await document.StorePictureFromBlob("Chat", resu.Data.Id, event)
      } else {
        await document.StorePictureFromEvent("Chat", resu.Data.Id, event)
      }
      await document.sendToServer()

    }
  }

  async TrasnfertAskTo(party, email) {
    let resu = await this.manager.Ws.Send("Asks", "transfert", { Id: this.id, party: party, email: email }, true)
    if (resu.error) this.manager.Tool.notify(this.manager.Trad.Parse(resu.error))
    if (resu.success) this.manager.Tool.notify(this.manager.Trad.Parse(resu.success))
  }

  async postDisplayHtmlField(documentPopUp) {
    await Promise.all(Object.values(this.Structure).map((field: Field) => field.postRenderHtml(this, { popup: documentPopUp })))
    this.modified = false
  }

  async DestroyFields() {
    let promises = new Array<Promise<any>>()
    for (const [key, field] of Object.entries(this.Structure))
      promises.push(field.Destroy())
    await Promise.all(promises).catch(LoggerService.error)

  }

  async CleanBaseFolder() {
    await this.manager.Documents.deleteDirectory("Ask" + this.id)
  }

  async Destroy() {
    if (!this.isFake) return;
    for (let field of this.Structure) {
      if (field.Type == "document") {
        for (const document of field.Value as Array<Documents>)
          await document.removeFile()
      }
      await field.Destroy()
      field = null
    }
    await this.CleanBaseFolder()
    this.structure = []
  }

}
